import { transformValues } from './transformValues';

export function transformFields(response = {}, addressFieldMap) {
  return Object.keys(addressFieldMap).reduce((data, fieldName) => {
    const daumFieldNames =
      typeof addressFieldMap[fieldName] === 'string'
        ? [addressFieldMap[fieldName]]
        : addressFieldMap[fieldName];

    if (!daumFieldNames) {
      data[fieldName] = undefined;
      return data;
    }

    let nextSeparator = '';

    data[fieldName] = daumFieldNames.reduce(
      (concatenatedValue, daumFieldName) => {
        // Look for a separator config between address text, separator starts with { and ends with }
        // Example: {/} between apartment name and apartment number should look like apartment name/apartment number
        const separatorMatch = daumFieldName.match(/^\{(.*)\}$/);

        if (separatorMatch) {
          nextSeparator = separatorMatch[1];
          return concatenatedValue;
        }

        const value = response[daumFieldName];
        const separator = concatenatedValue ? nextSeparator : '';

        const newConcatenatedValue = value
          ? `${concatenatedValue}${separator}${value}`
          : concatenatedValue;

        nextSeparator = '';
        return newConcatenatedValue;
      },
      ''
    );
    return data;
  }, {});
}

export { transformValues };
